import React from "react";
import { CheckIcon, CreditCardIcon, FileTextIcon, GiftIcon, PrinterIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHead } from "./SectionHead";
import { CHECKOUT_URL, bonuses, offerIncludes, product } from "../data/landing";
const deliveryItems = [{
  icon: FileTextIcon,
  label: "Digital PDF bundle"
}, {
  icon: PrinterIcon,
  label: "Printable worksheets"
}, {
  icon: CreditCardIcon,
  label: "One-time payment"
}];
export function OfferSection() {
  return <section id="offer-details" className="scroll-mt-16 bg-navy py-16 md:py-24" data-id="element-62" data-mp="me219nctkjoa">
      <div className="mx-auto max-w-[1180px] px-5 sm:px-8" data-id="element-63" data-mp="re67mkk0jy0s">
        <SectionHead tone="dark" eyebrow="Everything in one kit" title="Get New Manager" highlight="Essentials" data-id="element-64" data-mp="repmttia48b4" />

        <div className="mx-auto max-w-[600px] rounded-lg bg-white px-5 py-8 shadow-[0_30px_70px_rgba(0,0,0,0.35)] sm:px-10 sm:py-10" data-id="element-65" data-mp="wan7gc0ks0tp">
          <div className="text-center" data-id="element-66" data-mp="2y3umdkca0gf2">
            <span className="inline-block rounded-sm bg-soft px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-navy" data-id="element-67" data-mp="2y4mgsru5083r">
              Volume 01 · 10 workshops + 5 bonuses
            </span>
            <img src={product.mockup} alt="New Manager Essentials box set" width={1024} height={1536} loading="lazy" className="mx-auto mt-6 h-[280px] w-auto rounded-xl shadow-[0_16px_36px_rgba(19,34,56,0.18)]" data-id="element-68" data-mp="xvh4uahgv58q" />
            <h3 className="mt-6 font-display text-[34px] font-extrabold uppercase leading-none text-navy sm:text-[40px]" data-id="element-69" data-mp="1lka1k95wxh4e">
              {product.name}
            </h3>
            <p className="mx-auto mt-3 max-w-[440px] text-[15px] text-ink/80" data-id="element-70" data-mp="1ckd7fs0r7q1y">
              A 40-page facilitator playbook with 10 complete workshops for first-time managers, plus 5 bonus resources.
            </p>
          </div>

          <div className="my-7 border-t border-line" data-id="element-71" data-mp="14g8daz7bpr0" />

          <h4 className="text-center text-xs font-bold uppercase tracking-[0.16em] text-navy" data-id="element-72" data-mp="3sbsp5ow6a16e">What's included</h4>
          <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-73" data-mp="3tvasdysa34ak">
            {offerIncludes.map(item => <li key={item} className="flex items-center gap-2.5 text-[15px] font-medium text-ink" data-id="element-74" data-mp="2llvld940skr">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-wash" data-id="element-75" data-mp="3kve4w0hmkbh3">
                  <CheckIcon className="h-3 w-3 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-76" data-mp="3b3i1qb0olv60" />
                </span>
                {item}
              </li>)}
          </ul>

          <h4 className="mt-7 text-center text-xs font-bold uppercase tracking-[0.16em] text-navy" data-id="element-77" data-mp="3fw1g3a770ubv">
            Plus {bonuses.length} bonuses
          </h4>
          <ul className="mt-4 space-y-2.5" data-id="element-78" data-mp="365ggpkjp3lrw">
            {bonuses.map(bonus => <li key={bonus.title} className="flex items-center gap-2.5 text-[15px] font-medium text-ink" data-id="element-79" data-mp="2s4dwldc9gljm">
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal-wash" data-id="element-80" data-mp="2x2p6fo2k2w1u">
                  <GiftIcon className="h-3 w-3 text-teal" aria-hidden="true" data-id="element-81" data-mp="2diqctt9yzj1a" />
                </span>
                {bonus.title}
              </li>)}
          </ul>

          <div className="my-7 border-t border-line" data-id="element-82" data-mp="2mivfxr84rv9n" />

          <div className="text-center" data-id="element-83" data-mp="2mgae327u1fbw">
            <p className="flex items-end justify-center font-display font-extrabold leading-none text-navy" data-id="element-84" data-mp="2igs24vxzoel7">
              <span className="mb-2 text-4xl" data-id="element-85" data-mp="2wfrilgbcln6a">$</span>
              <span className="text-[96px] tracking-[-0.02em]" data-id="element-86" data-mp="2rhpz4ua0flua">{product.price}</span>
              <span className="mb-3 ml-2 font-sans text-sm font-medium text-muted" data-id="element-87" data-mp="2rflto7wgqerw">{product.currency}</span>
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs font-bold uppercase tracking-[0.14em] text-muted" data-id="element-88" data-mp="317rnzoa6t8a9">
              <span data-id="element-89" data-mp="3f82egq7l4kuw">One-time payment</span>
              <span data-id="element-90" data-mp="3f4y0x288ccrk">Digital PDF</span>
            </div>
          </div>

          <CtaButton href={CHECKOUT_URL} className="mt-7 w-full whitespace-normal" data-id="element-91" data-mp="3a9sg66qkd452">
            Get New Manager Essentials
          </CtaButton>

          <div className="mt-8 border-t border-line pt-5" data-id="element-92" data-mp="1dhv9rznsj4f1">
            <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-[13px] font-medium text-muted" data-id="element-93" data-mp="1dgaf8a1h7lh6">
              {deliveryItems.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-1.5" data-id="element-94" data-mp="1m959k8penws6">
                  <Icon className="h-4 w-4 text-teal" aria-hidden="true" data-id="element-95" data-mp="pkpha4uwv9bd" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-6 max-w-[600px] text-center text-[13px] text-white/70" data-id="element-96" data-mp="ykuh9txrz5fi">
          Price shown in USD. Editable presentation decks are not included.
        </p>
      </div>
    </section>;
}